import {BaseTileProvider} from './base-tile-provider';
import {environment} from '../../../../environments/environment';
import {MapType} from '../../enums/map-type';
import {sprintf} from 'sprintf-js';
import {MapProvider} from '../../enums/map-provider.enum';
import {SettingsService} from '../../services/settings.service';

export class MapboxTileProvider extends BaseTileProvider {

  // From the environment files (not in git); the browser sends it with every tile.
  private static MAPBOX_TOKEN = environment.mapboxTilesToken || '';

  // Raster Tiles API: only for raster tilesets (the satellite imagery).
  private static URL_MAPBOX = 'https://api.mapbox.com/v4/{l}/{z}/{x}/{y}@2x.jpg?access_token=' + MapboxTileProvider.MAPBOX_TOKEN; // [map_id]
  // Static Tiles API: a rendered Mapbox style. Streets and terrain are vector
  // tilesets, which the Raster Tiles API only draws as a debug view.
  private static URL_MAPBOX_STYLE = 'https://api.mapbox.com/styles/v1/mapbox/{l}/tiles/256/{z}/{x}/{y}@2x?access_token=' + MapboxTileProvider.MAPBOX_TOKEN; // [style_id]

  private static MAPBOX_SATELLITE_ID = 'mapbox.satellite';
  private static MAPBOX_STREETS_STYLE = 'streets-v12';
  private static MAPBOX_SATELLITE_STREETS_STYLE = 'satellite-streets-v12';
  private static MAPBOX_OUTDOORS_STYLE = 'outdoors-v12';

  getMapProvider(): string {
    return MapProvider.MAPBOX;
  }

  getMaxZoom(): number {
    // The Static Tiles API refuses anything past 22, so deeper zooms stretch
    // the z22 tiles instead of asking for ones that do not exist.
    return 22;
  }

  getUrlTemplate(mapType?: MapType): string {
    let mt = mapType;
    if(!mt){
      mt = SettingsService.settings.mapType;
    }
    let url = '';
    switch (mt) {
      case MapType.MAP:
        url = MapboxTileProvider.URL_MAPBOX_STYLE.replace('{l}', MapboxTileProvider.MAPBOX_STREETS_STYLE);
        break;
      case MapType.SATELLITE:
        url = MapboxTileProvider.URL_MAPBOX.replace('{l}', MapboxTileProvider.MAPBOX_SATELLITE_ID);
        break;
      case MapType.HYBRID:
        url = MapboxTileProvider.URL_MAPBOX_STYLE.replace('{l}', MapboxTileProvider.MAPBOX_SATELLITE_STREETS_STYLE);
        break;
      case MapType.TERRAIN:
        url = MapboxTileProvider.URL_MAPBOX_STYLE.replace('{l}', MapboxTileProvider.MAPBOX_OUTDOORS_STYLE);
        break;
    }
    return url;
  }

  getUrl(x, y, zoom, mapType?: MapType): string {
    return this.getUrlTemplate(mapType)
      .replace('{z}', zoom)
      .replace('{x}', x)
      .replace('{y}', y);
  }

}
